import React from 'react';
import styles from './Footer.less';

const Footer = () => (<div className={styles.footer}>
  DongHanh Online Accouting System  © 2017 DH-Tech
                      </div>);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Layout/Footer.js